@import (reference) "../../styles/variables.less";
@import (reference) "../../styles/buttons.less";
@import (reference) "../../styles/animations.less";

@header-h: 56px;

// Breakpoints are copied from existing implementation in LT
@desktop-bp: 1010px;
@tablet-bp: 767px;
@mobile-bp: 480px;

:host {
  container-name: main;
  container-type: inline-size;
  display: block;
  position: sticky;
  top: 0;
  z-index: 1;
}

button {
  background: none;
  border: none;
  transition: background-color 0.15s ease, transform 0.1s ease;

  &:hover, &:focus {
    will-change: transform;
  }

  &:active {
    transform: scale(0.98);
  }
}

ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.hidden {
  display: none !important;
}

.main-container {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.site-header {
  background-color: @lt-blue-deep;
  color: @white;
  display: flex;
  height: @header-h;
  margin: 0;
  padding: 0;
}

.main-nav {
  align-items: center;
  display: flex;
  justify-content: space-between;

  @container main (width <= @desktop-bp) {
    display: none;
  }
}

.nav-list {
  align-items: center;
  display: flex;

  @container main (width <= @tablet-bp) {
    flex-grow: 1;
  }
}

.nav-actions {
  align-items: center;
  display: flex;
  gap: @spacer-2;
  margin: 0 @spacer-2b + @header-h 0 0;

  @container main (width > @desktop-bp) {
    margin-right: @spacer-2b;
  }
}

.nav-action {
  align-items: center;
  border: 2px solid @white;
  border-radius: @radius-4;
  color: @white;
  display: flex;
  font: @lt-font-primary;
  font-weight: bold;
  height: 31px;
  justify-content: center;
  text-decoration: none;

  &.sign-up {
    width: 78px;

    @container main (width <= @tablet-bp) {
      display: none;
    }
  }

  &.sign-in {
    width: 70px;

    @container main (width <= @tablet-bp) {
      display: none;
    }
  }

  &:hover, &:focus {
    background-color: @lt-blue-dark-1;
    cursor: pointer;
  }

  &:active {
    transform: scale(0.98);
  }
}


.personal-item {
  @container main (width <= @tablet-bp) {
    display: none;
  }
}

.nav-item, .personal-item {
  max-width: 300px;
  position: relative;
  top: 6px;

  &.logo {
    flex-grow: 1;
    max-width: unset;
    top: 0;

    @container main (width <= @tablet-bp) {
      align-items: center;
      display: flex;
      justify-content: center;
    }
  }
}

.nav-link {
  align-items: center;
  background: none;
  border: none;
  color: @white;
  cursor: pointer;
  display: inline-flex;
  font: @lt-font-primary;
  font-weight: bold;
  gap: @spacer-1;
  padding: @spacer-1 @spacer-2 @spacer-3;
  text-decoration: none;
  transition: background-color 0.15s ease, color 0.15s ease, transform 0.1s ease;

  &:hover, &:focus {
    will-change: transform;
  }

  &.open {
    background-color: @white;
    border-top-left-radius: @radius-1;
    border-top-right-radius: @radius-1;
    color: @lt-blue-deep;
  }

  &:active {
    transform: scale(0.98);
  }

  &.logo {
    padding: 0 12px;

    svg {
      height: 38px;
    }
  }
}

.submenu {
  .fade-in-opacity();

  background-color: @white;
  box-shadow: 0 6px 6px 0 oklch(0 0 0deg / 24%);
  display: none;
  left: 0;
  min-width: 236px;
  position: absolute;
  text-align: left;
  top: 100%;

  &.open {
    display: block;
  }

  &.personal {
    left: unset;
    right: 0;
  }

  a {
    color: @text-gray;
    display: block;
    font: @lt-font-primary;
    padding: 16px;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      background-color: @lt-blue-light-3;
      font-weight: bold;
    }
  }
}

.nav-search {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: transform 0.1s ease;

  &:hover, &:focus {
    will-change: transform;
  }

  &:active {
    transform: scale(0.95);
  }
}

li.side-section {
  bottom: 0;
  position: absolute;
  right: 0;
  top: 0;

  @container main (width > @desktop-bp) {
    display: none;
  }
}

button.side-section {
  display: none;
  transition: background-color 0.15s ease, transform 0.1s ease;

  &:hover, &:focus {
    will-change: transform;
  }

  @container main (width <= @desktop-bp) {
    align-items: center;
    background-color: @lt-blue-deep-light-1;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: @spacer-3;
  }

  &:active {
    transform: scale(0.95);
  }
}

.side-container {
  background-color: @lt-blue-deep;
  bottom: 0;
  position: fixed;
  right: 0;
  top: @header-h;
  width: 300px;

  @container main (width > @desktop-bp) {
    display: none;
  }

  @container main (width <= @mobile-bp) {
    width: 100%;
  }
}

.search-section {
  @container main (width <= @tablet-bp) {
    display: none;
  }
}

.search-container {
  .fade-in-opacity();

  background-color: @white;
  box-shadow: 0 6px 6px 0 oklch(0 0 0deg / 24%);
  left: 0;
  position: fixed;
  right: 0;
  top: @header-h;

  .clear-search {
    cursor: pointer;
    font-size: @spacer-4;
    height: @spacer-4;
    margin: 0;
    padding: 0;

    &.hidden {
      display: none;
    }
  }

  .error {
    color: @lt-electric-salmon;
    display: block;
    font: bold 14px/1 @lt-font-family-primary;
    padding-bottom: @spacer-2;
    padding-left: calc(calc(100% - min(620px, 100%)) / 2);
    text-align: left;
  }

  @container main (width <= @tablet-bp) {
    display: none;
  }
}

.search-form {
  display: flex;
  gap: @spacer-4;
  justify-content: center;
  padding: @spacer-3;

  &.with-error {
    padding-bottom: @spacer-2;
  }
}

.search-label {
  width: 500px;
}

.search-submit {
  .button-common();
  .button-size-medium();
  .button-primary-blue();

  font: bold 16px/1 @lt-font-family-primary;
}

.side-menu {
  background-color: @lt-blue-deep;
  bottom: 0;
  position: fixed;
  right: 0;
  top: @header-h;
  width: 300px;
}

.mobile-login {
  display: none;
  padding: 0 0 0 @spacer-3;


  @container main (width <= @tablet-bp) {
    display: block;
  }

  .sign-in {
    align-items: center;
    border: 2px solid @white;
    border-radius: @radius-4;
    color: white;
    display: flex;
    font: @lt-font-primary;
    font-weight: bold;
    height: 31px;
    justify-content: center;
    text-decoration: none;
    width: 70px;

    &:hover, &:focus {
      background-color: @lt-blue-dark-1;
      cursor: pointer;
    }

    &:active {
      transform: scale(0.98);
    }
  }
}
